import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideModal, showModal } from "../../../../actions/modals";
import api from '../../../../api/index';
import Spiner from "../../../common/Spiner";

class OwnerSynchronizationModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            ID: '',
            name: '',

            callback: () => { },
        };
    }

    componentDidMount() {
        if (typeof this.props.propsData != 'undefined') {
            this.setState({
                ID: this.props.propsData.ID,
                name: this.props.propsData.Name,

                callback: this.props.propsData.callback
            })
        }
    }

    handleSynchronization = () => {

        let reqData = {
            ID: this.state.ID
        };

        this.props.dispatchHideModal();
        this.props.dispatchShowModal('INFO_MODAL', { title: 'Синхронізація Uployal', description: 'Виконується синхронізація Uployal...', type: null })

        api.apiSynchronizationOwner(reqData).then(res => {
            this.setState({ loading: false });
            if (res.status == 200) {
                this.props.dispatchHideModal();
                this.props.dispatchShowModal('INFO_MODAL', { title: 'Синхронізація Uployal', description: 'Синхронізація Uployal успішна', type: true })
                this.state.callback();
            } else {
                this.props.dispatchHideModal();
                this.props.dispatchShowModal('INFO_MODAL', { title: 'Синхронізація Uployal', description: 'Синхронізація Uployal не успішна. Зверніться до адміністратора', type: false })
            }
        }).catch(error => {
            this.setState({ loading: false });
            this.props.dispatchHideModal();
            this.props.dispatchShowModal('INFO_MODAL', { title: 'Синхронізація Uployal', description: error.response.data.message, type: false });
        });
    };

    render() {
        return (
            <div>
                <div className="modal-header">
                    <button type="button" className="close" onClick={this.props.closeModal}>
                        <i className="fa fa-times"></i>
                    </button>
                    <h5 className="modal-title">Синхронізація Uployal</h5>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div>
                                Ви дійсно хочете синхронізувати Uployal
                            </div>
                        </div> 
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="row">
                        <div className="col-lg-12">
                            <button
                                disabled={this.state.loading}
                                onClick={this.handleSynchronization}
                                type="button"
                                className="btn btn-primary"
                            >
                                {
                                    !this.state.loading
                                        ? <span>Так</span>
                                        : <span>Синхронізуємо</span>
                                }
                                {!this.state.loading ? null : <Spiner />}
                            </button>
                            <button onClick={this.props.closeModal} type="button" className="btn btn-secondary">Відмінити</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        state
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchShowModal: (type, data) => dispatch(showModal(type, data)),
        dispatchHideModal: (type, data) => dispatch(hideModal(type, data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(OwnerSynchronizationModal);
